module.exports = __webpack_public_path__ + "static/media/munikum-local.fac76703.graphqls";